(function ($) {
    var currentGlossaryPage = 1;
    var glossaryAjax        = null;
    var glossaryTimeout     = null;

    var loadGlossary = function () {
        var template  = $('#js-glossary-item').html();
        var $list     = $('.js-glossary-listing');
        var $loadMore = $('.js-glossary-next-page');

        Mustache.parse(template);

        var data = {
            nonce: rissb_var.nonces.get_glossary,
            page: currentGlossaryPage,
            filters: {
                s: $('[name="glossary_s"]').val(),
                index: $('.index-list.active .index-item').text(),
                glossary_disciplines: $('.filter-desktop input[name="glossary_disciplines[]"]:checked').map(function () {
                    return $(this).val();
                }).get(),
                glossary_categories: $('.filter-desktop input[name="glossary_categories[]"]:checked').map(function () {
                    return $(this).val();
                }).get(),
            },
        };

        if (window.matchMedia('(max-width: 768px)').matches) {
            data.filters.glossary_disciplines = $('.filter-mobile input[name="glossary_disciplines[]"]:checked').map(function () {
                    return $(this).val();
                }).get();

            data.filters.glossary_categories = $('.filter-mobile input[name="glossary_categories[]"]:checked').map(function () {
                    return $(this).val();
                }).get();
            data.filters.s = $('.filter-mobile [name="glossary_s2"]').val();
        } else {
            data.filters.s = $('.filter-desktop [name="glossary_s"]').val();
        }

        if (data.page == 1) {
            $list.empty();
        }

        if (glossaryAjax) {
            glossaryAjax.abort();
        }

        glossaryAjax = $.post('/api/glossary', data, function (res) {
            var rendered = Mustache.render(template, res.data);

            if (data.page == 1) {
               $list.html(rendered);
            } else {
                $list.append(rendered);
            }

            $loadMore.closest('div').toggleClass('d-none', res.data.pagination.total <= res.data.pagination.current);
        }).always(function () {
            $loadMore.text($loadMore.data('text-original'));
        });
    };

    $(document).ready(function () {
        if ($('body').hasClass('page-template-template-glossary')) {
            RISSB.fn.clearDropdownFilter(function () {
                currentGlossaryPage = 1;
                loadGlossary();
            });

            loadGlossary();

            $('.js-glossary-filters').each(function () {
                const $filters = $(this);
                const $searchInput = $filters.find('.js-glossary-search');
                const $errorElement = $filters.find('.js-search-error');
            
                console.log('Found error element:', $errorElement.length); // debug
            
                $searchInput.on('keyup input', function () {
                    var searchTerm = $(this).val();
                    console.log('Search term:', searchTerm); // debug
            
                    clearTimeout(glossaryTimeout);
            
                    if (searchTerm.length > 0 && searchTerm.length < 3) {
                        console.log('Too short, showing error');
                        $errorElement.removeClass('d-none').addClass('d-block'); // force toggle
                        return;
                    }
            
                    console.log('Valid or empty, hiding error');
                    $errorElement.removeClass('d-block').addClass('d-none');
            
                    if (searchTerm.length >= 3 || searchTerm.length === 0) {
                        glossaryTimeout = setTimeout(loadGlossary, 500);
                    }
                });
            });            

            $('.js-update-filter').on('click', function () {
                var $this = $(this);
                currentGlossaryPage = 1;

                RISSB.fn.updateQSParams('glossary_disciplines[]', $this.closest('.js-glossary-filters').find('input[name="glossary_disciplines[]"]:checked').map(function () {
                    return $(this).val();
                }).get(), true);

                RISSB.fn.updateQSParams('glossary_categories[]', $this.closest('.js-glossary-filters').find('input[name="glossary_categories[]"]:checked').map(function () {
                    return $(this).val();
                }).get(), true);

                loadGlossary();
                $this.closest('.dropdown-menu').removeClass('show');
            });

            $('.index-item').on('click', function (e) {
                e.preventDefault();

                $('.index-list').removeClass('active');
                $(this).closest('li').toggleClass('active');

                RISSB.fn.updateQSParams('index', $('.index-list.active .index-item').text());
                $('.index-list-clear').removeClass('d-none');

                currentGlossaryPage = 1;
                loadGlossary();
            });

            if ($('.index-list.active').length) {
                $('.index-list.active .index-item').click();
            }

            $('.index-item-clear').on('click', function (e) {
                e.preventDefault();
                $('.index-list').removeClass('active');
                RISSB.fn.updateQSParams('index', null);
                $('.index-list-clear').addClass('d-none');

                currentGlossaryPage = 1;
                loadGlossary();
            });

            $('.js-glossary-listing').on('click', '.js-related-term', function (e) {
                e.preventDefault();

                // Reset all checkbox, and active index
                $('.js-dropdown-filter .dropdown-menu').find('input[type="checkbox"]').prop('checked', false);
                $('.js-dropdown-filter .dropdown-menu').find('input[type="checkbox"]').eq(0).change();
                $('.index-list').removeClass('active');
                $('[name="glossary_s"]').val($(this).text());

                currentGlossaryPage = 1;
                loadGlossary();
            });

            $('.js-glossary-next-page').on('click', function (e) {
                e.preventDefault();

                var $this = $(this);
                currentGlossaryPage = currentGlossaryPage + 1;

                $this.html('<i class="fas fa-spinner fa-spin fa-fw"></i> ' + $this.data('text-progress'));
                loadGlossary();
            });
        }
    });
})(jQuery);

